module.exports = __webpack_public_path__ + "images/3-h32e3372b20818515627f66d9d93fd5c7.svg";